export default __webpack_public_path__ + "static/media/klisbio.eb1ed09c.png";